export default __webpack_public_path__ + "static/media/home-interactive-portfolio-img-01.739d90b3.jpg";